import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import SpreadsheetGuide from "../pages/article/kakobuy-spreadsheet-guide/page";
import CSSBuySpreadsheet from "../pages/article/cssbuy-spreadsheet/page";
import SuperbuySpreadsheet from "../pages/article/superbuy-spreadsheet/page";
import QCSpreadsheet from "../pages/article/qc-spreadsheet/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/kakobuy-spreadsheet-guide",
    element: <SpreadsheetGuide />,
  },
  {
    path: "/cssbuy-spreadsheet",
    element: <CSSBuySpreadsheet />,
  },
  {
    path: "/superbuy-spreadsheet",
    element: <SuperbuySpreadsheet />,
  },
  {
    path: "/qc-spreadsheet",
    element: <QCSpreadsheet />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;